import React, { useState } from "react";
import { IconButton, withStyles } from "@material-ui/core";
import { ReactComponent as NorthIcon } from "../../assets/images/icons/north.svg";
import { ReactComponent as EastIcon } from "../../assets/images/icons/east.svg";
import { ReactComponent as SouthIcon } from "../../assets/images/icons/south.svg";
import { ReactComponent as WestIcon } from "../../assets/images/icons/west.svg";
import { ReactComponent as VideoIcon } from "../../assets/images/icons/video.svg";
import { ReactComponent as NorthEstIcon } from "../../assets/images/icons/north-est.svg";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { carousel } from "../../store";
import ImageGallery from "react-image-gallery";
import classNames from "classnames";
import { Close as CloseIcon } from "@material-ui/icons";
import ReactPlayer from "react-player";
import styles from "./styles";

function RightMedia({ classes, medias }) {
	const [isOpenSlider, setIsOpenSlider] = useState(false);
	const [isOpenVideo, setIsOpenVideo] = useState(false);
	const [playVideo, setIsPlayVideo] = useState(false);
	const [pauseVideo, setIsPauseVideo] = useState(false);
	const [controls, setControls] = useState(true);

	const [images, setImages] = useState({ title: "", src: [] });
	const [video, setVideo] = useState([]);

	const handleVideo = () => {
		setIsOpenVideo(true);
		setVideo(medias["video"]);
	};
	const handleMediaType = type => {
		setIsOpenSlider(true);
		let gallery;
		gallery = medias[type].map(item => ({
			original: item,
			thumbnail: item
		}));
		setImages({ title: type.split("-").join(" "), src: gallery });
	};
	const handleCloseSlideShow = () => {
		setIsOpenSlider(false);
		setIsOpenVideo(false);
		setImages({});
	};
	return (
		<>
			<div className={classNames(classes.mediaIcons)}>
				<div>
					<NorthIcon
						className={classNames(classes.icon)}
						onClick={() => handleMediaType("vue-nord")}
					/>
					<NorthEstIcon
						className={classNames(classes.icon)}
						onClick={() => handleMediaType("vue-nord-est")}
					/>
					<EastIcon
						className={classNames(classes.icon)}
						onClick={() => handleMediaType("vue-est")}
					/>

					<WestIcon
						className={classNames(classes.icon)}
						onClick={() => handleMediaType("vue-ouest")}
					/>
					<SouthIcon
						className={classNames(classes.icon)}
						onClick={() => handleMediaType("vue-sud")}
					/>
					<VideoIcon
						className={classNames(classes.icon)}
						onClick={handleVideo}
					/>
				</div>
			</div>

			{(isOpenSlider || isOpenVideo) && (
				<div className={classNames(classes.mediaSlideShow)}>
					<h6>{images.title}</h6>
					<IconButton
						aria-label="Close"
						className={classNames(classes.closeSlideShowBtn)}
						onClick={handleCloseSlideShow}
					>
						<CloseIcon fontSize="large" />
					</IconButton>
					{isOpenSlider && (
						<ImageGallery
							items={images.src}
							showThumbnails={false}
							showFullscreenButton={false}
							showPlayButton={false}
							fullscreen={true}
						/>
					)}
					{isOpenVideo && (
						<div className={classNames(classes.officeVersionVideo)}>
							<ReactPlayer
								playing={playVideo}
								controls={controls}
								className={classNames(classes.video, "app-video")}
								url={video}
								width="100%"
								height="100%"
								onPause={() => {
									setIsPlayVideo(false);
									setIsPauseVideo(true);
								}}
								onPlay={() => {
									setIsPlayVideo(true);
									setIsPauseVideo(true);
								}}
								onClick={() => {
									setIsPlayVideo(!playVideo);
									setIsPauseVideo(true);
									setControls(true);
								}}
							/>
						</div>
					)}
				</div>
			)}
		</>
	);
}

const mapStateToProps = state => ({
	medias: state.carousel[state.helpers.building]
});

const mapDispatchToProps = dispatch =>
	bindActionCreators({ fetchMedia: carousel.fetchMedia }, dispatch);

RightMedia.propTypes = {
	classes: PropTypes.object.isRequired,
	isMediaShow: PropTypes.string
};

export default withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(RightMedia)
);
